var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.size === 'small' ? 'chi-photo-xs' : 'chi-photo']},[_c('img',{staticClass:"rounded-full",attrs:{"src":_vm.profilePhoto,"alt":_vm.alt,"title":_vm.alt},on:{"error":_vm.imgPlaceholder}})])}
var staticRenderFns = []

export { render, staticRenderFns }